/**
 *
 * Resets the filters when the user clicks the "Clear Filters" button
 *
 */
import {initialState} from "./globals";

export const resetURLParams = () =>{
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.delete('effort-level');
    params.delete('main-ingredient');
    params.delete('cooking-time');
    params.delete('course');
    params.delete('diet');
    params.delete('style');
    params.delete('fuel-type');
    params.delete('featured');
    params.delete('orderby');
    window.history.replaceState({}, '', `${url.pathname}`);
}

export const resetFastFilters = () =>{
    const fastFilters = document.getElementsByClassName('js-fast-filter');

    // Reset other fast filters
    for (let i=0; i< fastFilters.length; i+=1) {
        fastFilters[i].classList.remove('active');
    }
}

export const resetNavFilters = (setActiveFilters, setActiveFiltersCounter, setApplyState) => {
    // Reset any checkboxes in the slide-out nav
    const checkboxes = document.getElementsByClassName('js-filter-checkbox');
    for (let i=0; i< checkboxes.length; i+=1) {
        if (checkboxes[i].checked){
            checkboxes[i].click();
        }
    }

    setApplyState(initialState);

    const emptyArray = []
    setActiveFilters(emptyArray);
    setActiveFiltersCounter(0);
}


export default resetURLParams;
